<template>
  <div class="header-navegation-menu">
    <HoritzontalScrollable ref="hs">
      <template v-slot:content>
        <v-menu 
          offset-y 
          max-width="300px"
          v-for="menu in all_menus_tree"
          v-bind:key="menu.id"
          v-if="menu.enabled"
          open-on-hover
          close-on-click
          content-class="qmkey-toolbar-menu-contents elevation-1"
        >

          <template v-slot:activator="{ on, attrs }">
            <v-btn
              text
              :color="is_menu_active(menu) ? 'primary' : '#404040'"
              v-bind="attrs"
              v-on="on"
              position="left center"
              :class="'qmkey-toolbar-navigation-items' + (is_menu_active(menu) ? '-active' : '')"
            >
              {{menu.name}}
            </v-btn>
          </template>
          <div class="header-menu-content">
            <v-treeview
              dense
              :items="menu.children"
              class="qmkey-treeview-navegation-menu pt-0 pb-0"
              :active="currentMenus.map(it => it.id)"
              :open="currentMenus.map(it => it.id)"
              style="background-color: white;"
              hoverable
              multiple-active
            >
              <template v-slot:label="{item}">
                <div
                  v-if="item.url"
                  :disabled="!item.url"
                  :class="[item.url ? 'qmkey-toolbar-menu-item' : 'qmkey-toolbar-menu-item-disabled grey--text text--darken-4 v-subheader subheader']"
                  :input-value="is_menu_active(item)"
                  active-class="qmkey-toolbar-menu-item-active"
                  @click="goToMenu(item)"
                >
                  {{ item.name }}
                </div>
                <div
                  class="grey--text text--darken-4" 
                  v-else
                  style="font-weight: bolder;"
                >
                  {{item.name}}
                </div>
              </template>
            </v-treeview>
          </div>
        </v-menu>
      </template>
    </HoritzontalScrollable>
  </div>
</template>


<style lang="scss">
 @import "@/sass/header.scss";
</style>


<script>
 import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
 import HoritzontalScrollable from '@/components/HoritzontalScrollable';
 import QTree from '@/utils/QTree';

 function is_element_overflowing_x(elem) {
   return elem.scrollWidth > elem.clientWidth;
 }

 export default {
   name: 'NavegationMenu',

   components: {
     HoritzontalScrollable,
   },

   data: () => ({
     // :)
   }),

   computed: {
     ...mapGetters(['isManager', 'isAdmin']),
     ...mapState([
       'menus',
     ]),

     allmenus() {
       // Returns [static menus + automatic menus]
       return ([
         { // Admin menu
           id: -1,
           name: this.isAdmin ? 'Admin' : 'Manager',
           enabled: this.isAdmin || this.isManager,
           order: 0,
           parent: null,
           path: '/',
           site: null,
           url: null,
           items: [{
             id: -2,
             enabled: this.isAdmin,
             order: 0,
             path: '/',
             site: null,
             name: 'Empresas',
             url: '/sites',
             items: [],
           }, {
             id: -3,
             enabled: this.isAdmin,
             order: 0,
             path: '/',
             site: null,
             name: 'Centros',
             url: '/centros',
             items: [],
           }, {
             id: -4,
             enabled: this.isAdmin || this.isManager,
             order: 0,
             path: '/',
             site: null,
             name: 'Users',
             url: '/users',
             items: [],
           }, {
             id: -5,
             enabled: this.isAdmin,
             order: 0,
             path: '/',
             site: null,
             name: 'Menus',
             url: '/menus',
             items: [],
           }, {
             id: -6,
             enabled: this.isAdmin,
             order: 0,
             path: '/',
             site: null,
             name: 'Vocabulary',
             url: '/vocabularies',
             items: [],
           }, {
             id: -7,
             enabled: this.isAdmin,
             order: 0,
             path: '/',
             site: null,
             name: 'Roles',
             url: '/roles',
             items: [],
           }, {
             id: -8,
             enabled: this.isAdmin,
             order: 0,
             path: '/',
             site: null,
             name: 'IA',
             url: '/aiadmin',
             items: [],
           }, {
             id: -9,
             enabled: this.isAdmin,
             order: 0,
             path: '/',
             site: null,
             name: 'BPExplorer',
             url: '/bpexplorertable',
             items: [],
           }, {
             id: -10,
             enabled: this.isAdmin,
             order: 0,
             path: '/',
             site: null,
             name: 'Mapa de Procesos',
             url: '/processes',
             items: [],
           }, {
             id: -11,
             enabled: this.isAdmin,
             order: 0,
             path: '/',
             site: null,
             name: 'Carpetas',
             url: '/directories',
             items: [],
           }, {
             id: -12,
             enabled: this.isAdmin,
             order: 0,
             path: '/',
             site: null,
             name: 'Matriz de riesgos',
             url: '/risk_matrix',
             items: [],
           }, {
             id: -13,
             enabled: this.isAdmin,
             order: 0,
             path: '/',
             site: null,
             name: 'BPCreator',
             url: '/bpplayground',
             items: [],
           }],
         },
       ]).concat(this.menus);
     },

     currentMenus() {
       // Returns [{menu}, {submenu}, {subsubmenu}] or []
       function url2regex(url) {
         // https://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
         return new RegExp(url.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&') + "(&|$)");
       }
       function exploreSubmenus(url, menus) {
         // Parameter menus is a list of menus: [{menu}, {menu}]
         // Returns [{menu}, {submenu}, {subsubmenu}] or null
         // WARNING: compares urls with url.split('&')[0].
         //          TODO: Fix this behaviour in a business_process urls refactor.
         for (const menu of (menus || [])) {
           if (menu.url && url2regex(menu.url).test(url))
             return [menu];
           let match = exploreSubmenus(url, menu.items);
           if (match)
             return ([menu]).concat(match);
         }
         return null;
       }
       // Tell Vue that we are watching this.$route, otherwise it won't update me
       this.$route;
       return exploreSubmenus(this.$router.currentRoute.fullPath, this.allmenus) || [];
     },

     all_menus_tree() {
      const tree = new QTree(this.allmenus.map(men => ({...men,'children': men.items}))).map((it) => ({...it,'children': it.items})).filter('enabled',true);
      tree.custom_tree_sort('order');
      return tree.get_array_tree();
     }
   },

   methods: {
     is_menu_active(menu) {
       return this.currentMenus.some(m => m.id == menu.id);
     },

     goToMenu(menu) {
       if (!menu.url || menu.url == this.$router.currentRoute.fullPath)
         return;
       this.$router.push(menu.url.replace(/^\//, ''));
     },
   },

   watch: {
     menus() {
       this.$refs.hs.update();
     },
   },
 };
</script>
